import React from "react";
import Images from "../assets/Image";

export default function ProductHeader(props) {
  return (
    <div className="headerMainContainer">
      <div className="TopContainer">
        <div className="headerTextContainer">
          <div className="headerTxt">{props && props?.headerTxt}</div>
        </div>
        <div className="headerImgContainer">
          <img
            className="headerImg"
            src={props?.printerImg}
            // alt=""
          />
        </div>
      </div>
      <div className="bottomContainer">
        <div className="bottomBtnContainer">
          {" "}
          <a href={props?.pdfFile} target="_blank">
            View Brochure
          </a>
        </div>
        <div className="bottomBtnContainer">
          <a href={props?.pdfFile} download={props?.headerTxt}>
            {" "}
            Download Brochure
          </a>
        </div>
        {/* <div className="bottomBtnContainer">
          <button>Watch Video</button>
        </div> */}
      </div>
    </div>
  );
}
